import { useState } from "react";
import { useModalActions } from "@store/modal/modal";
import {
  fetchCustomTransactionCategoryQuery,
  useGetTransactionCategories,
} from "@services/budget/queries";
import { RemoveBudgetTransactionCategoryModal } from "./RemoveBudgetTransactionCategoryModal";
import { RemoveBudgetTransactionCategoryWithExpensePlanModal } from "./RemoveBudgetTransactionCategoryWithExpensePlanModal";
import { RemoveBudgetTransactionCategoryWithTransactionsModal } from "./RemoveBudgetTransactionCategoryWithTransactionsModal";

export const useRemoveBudgetTransactionCategoryModal = () => {
  const { create } = useModalActions();

  const [isLoading, setIsLoading] = useState(false);

  const { data: transactionCategories } = useGetTransactionCategories();

  const openRemoveCategoryModal = async (transactionCategoryId: number) => {
    if (!transactionCategories) {
      return;
    }

    setIsLoading(true);

    const data = await fetchCustomTransactionCategoryQuery({
      transactionCategoryId,
    });

    // Case: category has no expense plans and no transactions
    if (!data.hasExpensePlans && !data.hasTransactions) {
      create((modalProps) => (
        <RemoveBudgetTransactionCategoryModal
          {...modalProps}
          transactionCategoryData={data}
        />
      ));
    }

    // Case: category has expense plans and no transactions
    if (data.hasExpensePlans && !data.hasTransactions) {
      create((modalProps) => (
        <RemoveBudgetTransactionCategoryWithExpensePlanModal
          {...modalProps}
          transactionCategoryData={data}
        />
      ));
    }

    // Case: category has transactions assignes but no expense plans
    if (!data.hasExpensePlans && data.hasTransactions) {
      create((modalProps) => (
        <RemoveBudgetTransactionCategoryWithTransactionsModal
          {...modalProps}
          transactionCategoryData={data}
          transactionCategories={transactionCategories}
        />
      ));
    }

    // Case: category has both expense plans and transactions
    if (data.hasExpensePlans && data.hasTransactions) {
      create((modalProps) => (
        <RemoveBudgetTransactionCategoryWithExpensePlanModal
          {...modalProps}
          transactionCategoryData={data}
          onSubmit={() => {
            create((modalProps) => (
              <RemoveBudgetTransactionCategoryWithTransactionsModal
                {...modalProps}
                transactionCategoryData={data}
                transactionCategories={transactionCategories}
              />
            ));
          }}
        />
      ));
    }

    setIsLoading(false);
  };

  return {
    openRemoveCategoryModal,
    isLoading,
  };
};
